import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../../../services/index';
import { Progress,message,Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker ,Select,DatePicker,Upload, Modal,   } from 'antd';
import {  LineOutlined,DoubleRightOutlined,DoubleLeftOutlined} from '@ant-design/icons';



const { TextArea } = Input;
const { Panel } = Collapse;
const { Option } = Select;

const buttonWidth = 70;

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}

function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}



function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

function yearDiff(dt1, dt2) 
 {
 
  var diffYear =(dt2.getTime() - dt1.getTime()) / 1000;
   diffYear /= (60 * 60 * 24);
  return Math.abs(Math.round(diffYear/365.25));
   
 }

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			academic_year: '',
			name: '',
			details: '',
			package_details: [],
		}
		this.handleSizeChange = this.handleSizeChange.bind(this);
		this.change_year = this.change_year.bind(this);	
		this.handleSubmit = this.handleSubmit.bind(this);
		
		
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		this.setState({ user_id : storedArray['data'][0]['user_id'],program_id : this.props.match.params.id,school_id : storedArray['data'][0]['school_id'] });
		}
		
		this.checkData();
	}
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			var app = {id : this.props.match.params.id,user_id:user_id}
			getData('fees/package_details',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							package_details: result['data'],
							academic_year: result['data'][0]['academic_year'],
							name: result['data'][0]['name'],
							details: result['data'][0]['details'],
						});
					}else{
						this.setState({
							package_details: [],
						});
					}
				}
			});	
	}
  }
  
  
	 
	change_year(event){
         this.setState({academic_year: event});
		 document.getElementsByClassName('ant-select-selection')[0].classList.remove("error_focus");
     }
	 
	
	
	
	handleSizeChange = e => {		
		this.setState({ [e.target.name]: e.target.value });		
		if(e.target.name){
			document.getElementsByName(e.target.name)[0].classList.remove("error_focus");
		}
	 };
	  
	
	  
	  handleSubmit=(e)=>{
		e.preventDefault();
		if(localStorage.getItem('schoolData')){
		this.setState({ loading: true });
		
		var app = {
			
			user_id : this.state.user_id,
			school_id : this.state.school_id,
			academic_year : this.state.academic_year,
			name : this.state.name,
			details : this.state.details,
			id : this.props.match.params.id
			
		}
		getData('fees/edit_package',app).then((result) => {
			if(result.status==400){
				message.config({ top: 150});
				message.error(result.error_msg,2);
				if(result.error_name=='' && result.error_key!=''){
						document.getElementsByClassName('ant-select-selection')[result.error_key].classList.add("error_focus");
				}
				else{					
					if(result.error_name!=''){
						document.getElementsByName(result.error_name)[0].classList.add("error_focus");
					}					
				}
				this.setState({ loading: false });
			}
			else if(result.status==200){
				message.config({ top: 150});
				message.success('Fees Package Updated',2);
				this.setState({ loading: false });
				this.setState({comment_text:''});
				window.location.href = '/settings/fees/fees_package';
				
			}
			else{
				this.setState({ loading: false });
			}
		});
	  }else{
		message.error('Please Login',2);	
		this.setState({ loading: false });
	  }

  }
  
  
  
  
  
  
  

	render()

	{
	
	const { size } = this.state;
	const { previewVisible, previewImage, fileList, previewTitle } = this.state;
     
					
		return (
			<div class="mobile_view">
			
			<div id="main" class="bg-off">
         <div class="row">
		 
		 
		
		<div class="col col-md-12  ex-padd">
            <div id="breadcrumbs-wrapper" class="bg-off">
               <div class="">
                  <div class="row no-margin">
				  <div class="col s12 m12 header-title mt-20 mh-40 iq-card">
                    <div class="col s12 m6 l6 pb-15 mt-5">
                        <h5 class="breadcrumbs-title"><span class="back_arrow" onClick={this.context.router.history.goBack}><i class="ri-arrow-left-circle-line"></i></span><span class="main_title">Edit Fees Package</span></h5>
                     </div>
                     <div class="col s12 m6 l6 right-align-md pt-10">
                        <ol class="breadcrumbs mb-0">
                           <li class="breadcrumb-item"><a href="/">Home</a>
                           </li>
						  
						   <li class="breadcrumb-item "><a href="/settings/fees">Fees Setting</a>
                           </li>
						   <li class="breadcrumb-item "><a href="/settings/fees/fees_package">Fees Package</a>
                           </li>
						   <li class="breadcrumb-item active">Edit Package
                           </li>
                        </ol>
                     </div>
                     </div>
                  </div>
               </div>
            </div>
            </div>
            
            <div class="col col-md-12  ex-padd">
			
			{this.state.package_details.map((list)=>(
			
			<div class="container view-Profile child-profile view-Profile-mobile">
			   <div class="col col-md-12  mb-20 card-content iq-card">
                  <section class="invoice-list-wrapper section food mh-500">
					<div class="children mb-20  iq-card2 flow-root fees">
                     
						<div class="d-flex">
						  
						  <div class="col col-md-12 s12 pl-0">
						  
							<div class="col m12 s12 pl-0">	
								<div class="col m4 s12 mb-10 pb-20">
										<label>Academic Year</label>
										<Select onChange={this.change_year} defaultValue={this.state.academic_year}>
										 <Select.Option value="2022-2023">2022-2023</Select.Option>	
										 <Select.Option value="2021-2022">2021-2022</Select.Option>	
										 <Select.Option value="2020-2021">2020-2021</Select.Option>
										 <Select.Option value="2019-2020">2019-2020</Select.Option>
										 <Select.Option value="2018-2019">2018-2019</Select.Option>
										</Select>
								</div>	
								<div class="col m4 s12 mb-10">
									<label>Package Name</label>
									<input type="text" name="name" onChange={this.handleSizeChange} defaultValue={this.state.name}  required/>
								</div>	
							</div>	
								<div class="col m8 s12 mb-10 ">
										<label>Details</label>
										<TextArea
										  placeholder="Enter Details Here !!"
										  autoSize={{ minRows: 2, maxRows: 6 }}
										  onChange={this.handleSizeChange} 
										  name="details"
										  defaultValue={this.state.details} 
										/>
								</div>	
								
								
																
						  </div>
						</div>
							
						
					</div> 
					
					
					<div class="col col-md-12 s12 meal bt pt-10 mb-10 center">
						 <Button className="snd-btn"  onClick={this.handleSubmit} loading={this.state.loading}>Submit</Button>
					</div>
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
			
			))}
			
            </div>
         </div>
      </div>
     
			</div>
		) 
	} 
}
export default Index;
